export default __webpack_public_path__ + "static/media/equality-dk.dc5137c3.svg";